import React from 'react';

import { ListBannerView } from './ListBanner.view';

export interface BannerActionConfig {
  text: string;
  link: string;
}

interface ListBannerProps {
  title: string;
  items: Array<string>;
  primaryAction: BannerActionConfig;
  secondaryAction: BannerActionConfig;
  bannerImagePath?: string;
}

export const ListBanner: React.FC<ListBannerProps> = ({
  title,
  items,
  primaryAction,
  secondaryAction,
  bannerImagePath,
}: ListBannerProps) => {
  const openLink = (link: string) => {
    window.open(link, '_blank');
  };

  return (
    <ListBannerView
      title={title}
      items={items}
      primaryAction={{
        text: primaryAction.text,
        callback: () => openLink(primaryAction.link),
      }}
      secondaryAction={{
        text: secondaryAction.text,
        callback: () => openLink(secondaryAction.link),
      }}
      bannerImagePath={bannerImagePath}
    />
  );
};
